import React, { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ALERT_EXCLAIMATION_ICON, NEW_INSTAREM_LOGO_ICON } from '@Images';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import {
  GENERIC_ERROR_MSG,
  GO_TO_HELP_CENTER,
  HELP_CENTER,
  REFRESH_MSG
} from '../../utils/constants';
import { RUN_TIME_ERROR } from '../../utils/constants/eventsConstants';
import CommonButton from '../common-button/CommonButton';
import { logEvent } from '../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../utils/events/eventsConstants';

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .logo {
    width: 145px;
    height: 27px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 40%;
  height: 50vh;
  border: 1px solid ${COLORS.borderGreyLight};
  border-radius: 8px;
  margin-top: 60px;
  @media screen and (max-width: 912px) {
    width: 90%;
  }
  @media screen and (max-height: 440px) {
    height: 100%;
  }
  .alertIcon {
    width: 55px;
    height: 48px;
  }
  .helpCenterLink {
    margin-top: 16px;
  }
`;

const ErrorMessage = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 24px;
  line-height: 36px;
  margin-top: 35px;
`;

const Message = styled.div`
  line-height: 22px;
  margin: 16px 0px;
  max-width: 335px;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  width: 128px;
`;

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    logEvent(RUN_TIME_ERROR, null, { error, errorInfo }, LOG_TYPE.CLEVER_TAP);
  }

  refreshPage = (): void => {
    window.location.reload();
  };

  renderFallbackUI = (): React.ReactElement => {
    return (
      <OuterWrapper>
        <img src={NEW_INSTAREM_LOGO_ICON} className="logo" alt="Instarem Logo" />
        <Wrapper>
          <img src={ALERT_EXCLAIMATION_ICON} className="alertIcon" alt="!" />
          <ErrorMessage>{GENERIC_ERROR_MSG}</ErrorMessage>
          <Message>{REFRESH_MSG}</Message>
          <ButtonWrapper>
            <CommonButton onClick={this.refreshPage} width={128} height={36} text="Refresh" />
          </ButtonWrapper>
          <Link
            to={HELP_CENTER}
            className="helpCenterLink"
            onClick={() => {
              window.location.href = HELP_CENTER;
            }}
          >
            <CommonButton text={GO_TO_HELP_CENTER} type="link" fontSize={14} />
          </Link>
        </Wrapper>
      </OuterWrapper>
    );
  };

  public render(): ReactNode {
    if (this.state.hasError) {
      return this.renderFallbackUI();
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
